export const HIGH_PRIORITY_QUEUE = 'HIGH_PRIORITY_QUEUE';
export const LOW_PRIORITY_QUEUE = 'LOW_PRIORITY_QUEUE';
